export default __webpack_public_path__ + "static/fails-e106da837d9ba7c623c1d118c57ea371.png";